import React from 'react';

const About = () => (
  <section style={{ padding: 24 }}>
    <h2>About Us</h2>
    <p>
      Welcome to Online Crackers!<br />
      Address: <strong>Viswanatham, Sivakasi - 626189</strong><br />
      Phone: <strong>7667533653</strong>
    </p>
    <p>
      We are dedicated to providing quality crackers at the best prices, delivered safely and quickly to your doorstep.
    </p>
  </section>
);

export default About;
